<template>
  <div class="grid-inputs">
    <v-text-field
      v-for="(i, index) in code"
      :ref="`input${index}`"
      :key="index"
      v-model="code[index]"
      v-mask="['#']"
      :disabled="loading"
      :class="{ 'pin-input-error': error }"
      :error-messages="error ? 'error' : ''"
      outlined
      class="pin-input"
      type="text"
      autocomplete="off"
      @input="handleFocus(index + 1)"
      @keydown.delete="onDelete(index)"
      @focus="focusedIndex = index"
    />
  </div>
</template>

<script>
export default {
  props: ['error', 'loading'],
  data() {
    return {
      code: new Array(6),
      focusedIndex: 0
    }
  },
  watch: {
    code() {
      const sixDigitCode = this.code.filter(c => c).join('')
      this.$emit('send-code', sixDigitCode)
    },
    loading() {
      if (this.error && !this.loading) {
        const time = setTimeout(() => {
          this.$refs.input5[0].$el.getElementsByTagName('input')[0].focus()
          clearTimeout(time)
        }, 300)
      }
    }
  },
  mounted() {
    const time = setTimeout(() => {
      this.$refs.input0[0].$el.getElementsByTagName('input')[0].focus()
      clearTimeout(time)
    }, 300)
  },
  methods: {
    handleFocus(index) {
      this.$emit('remove-error')
      const refIndex = `input${index}`
      if (this.code[index - 1] && index < 6) this.$refs[refIndex][0].$el.getElementsByTagName('input')[0].focus()
    },
    onDelete(index) {
      if (this.code[this.focusedIndex]) return
      const refIndex = `input${index - 1}`
      if (this.code[index - 1]) this.$refs[refIndex][0].$el.getElementsByTagName('input')[0].focus()
    }
  }
}
</script>

<style lang="scss">
$tablet-size: 960px;
.grid-inputs {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 10px;
  max-width: 410px;
  & .v-text-field__details {
    display: none;
  }
}
.pin-input {
  & input {
    text-align: center;
    font-size: 25px;
  }
}

@media screen and (max-width: $tablet-size) {
  .grid-inputs {
    max-width: 100%;
  }
}
</style>
